import SelectDinamico from "../../SelectDinamico";

function SelectUsuario({campoUsuario, onChangeUsuario, disabled=false}){
    return (
        <SelectDinamico
            label="Solicitante"
            campoValue={campoUsuario}
            value={campoUsuario}
            cValue="Usuario"
            cText="Nome"
            consulta="Usuario"
            tabela="USER"
            isMultiplo={false}
            onchange={(e) => onChangeUsuario(e || '')}
            showNoFilter={false}
            disabled={disabled}
        />
    )
}

export default SelectUsuario;